<template>
  <el-container class="recharge">

    <el-header class="search">
      <el-input class="search-text" style="margin-left:-20px" v-model="keyWord" placeholder="请输入关键字检索..." @keyup.enter.native="BtnQuery"></el-input>
      <el-button type="primary" size="medium" plain icon="el-icon-search" @click="BtnQuery">查询</el-button>
    </el-header>

    <el-main>
      <div v-if="data.length > 0" class="recharge-data">
        <el-table
          ref="tableSort"
          v-loading="listLoading"
          :element-loading-text="loadingText"
          :data="data"
          style="width: 100%">
                <el-table-column
                  prop="ExamPaperName"
                  label="试卷名称"
                  align="left"
                ></el-table-column>

                <el-table-column
                  prop="ClassName"
                  label="类别"
                  align="center"
                :formatter="typeFormatter"
                ></el-table-column>

                <el-table-column
                  prop="BeginTime"
                  label="做卷时间"
                  align="center"
                  width="160"
                ></el-table-column>

                <el-table-column
                  prop="EndTime"
                  label="用时"
                  align="center"
                  width="100"
                :formatter="useTimeFormatter"
                ></el-table-column>

                <el-table-column
                  prop="Score"
                  label="得分"
                  align="center"
                  width="100"
                ></el-table-column>

                <el-table-column label="操作" align="center">
                  <template #default="{ row }">
                    <el-tag  size="small" type="danger" class="table-btn" @click="Delete(row)">
                      删除
                    </el-tag>
                    <el-tag size="small" class="table-btn" @click="Edit(row)">
                      重做
                    </el-tag>
                  </template>
                </el-table-column>
        </el-table>
      </div>
      <empty-data v-else></empty-data>
    </el-main>

    <el-footer v-if="data.length > 0" class="pagaing">
      <el-pagination
            :background="true"
            :current-page="pageIndex"
            :page-size="PageSize"
            :total="total"
            :layout="pageLayout"
            @current-change="PageChange"
            @size-change="SizeChange"
          ></el-pagination>
    </el-footer>
  </el-container>
</template>

<script>

import { GetPaperRecord, DelTestRecord } from "@/api/questionPaper";
import EmptyData from "@/components/EmptyData";
import { ExamStatusHelper } from "@/mixins/examStatusHelper";
import { CommonPage } from "@/mixins/commonData";

export default {
    components: { EmptyData },
    mixins: [ExamStatusHelper, CommonPage],
    data() {
        return {
            listLoading: false,
            loadingText: "正在加载...",
            pageLayout: "total, sizes, prev, pager, next, jumper",
            pageIndex: 1,
            PageSize: 10,
            total: 0,
            // 列表记录
            data: [],
            keyWord: ""
        }
    },
    computed: {},
    watch: {},
    created() {
        this.paperHistory()
    },
    methods: {
        getNowFormatDate(info) {
            var date = new Date();
            var year = date.getFullYear(); // 年 ,从 Date 对象以四位数字返回年份
            var month = date.getMonth() + 1; // 月 ,从 Date 对象返回月份 (0 ~ 11) ,date.getMonth()比实际月份少 1 个月
            var day = date.getDate(); // 日 ,从 Date 对象返回一个月中的某一天 (1 ~ 31)
            var hours = date.getHours(); // 小时 ,返回 Date 对象的小时 (0 ~ 23)
            var minutes = date.getMinutes(); // 分钟 ,返回 Date 对象的分钟 (0 ~ 59)
            var seconds = date.getSeconds(); // 秒 ,返回 Date 对象的秒数 (0 ~ 59)
            // 获取当前系统时间
            var currentDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            // 修改月份格式
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            // 修改日期格式
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }
            // 修改小时格式
            if (hours >= 0 && hours <= 9) {
                hours = "0" + hours;
            }
            // 修改分钟格式
            if (minutes >= 0 && minutes <= 9) {
                minutes = "0" + minutes;
            }
            // 修改秒格式
            if (seconds >= 0 && seconds <= 9) {
                seconds = "0" + seconds;
            }
            // 获取当前系统时间  格式(yyyy-mm-dd hh:mm:ss)
            var currentFormatDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            this.currentDay = currentFormatDate
            this.$router.push({
                path: "/examDetail",
                query: {
                    type: "school",
                    paperId: info.ExamPaperId,
                    scorePublish: "",
                    isCheckScore: true,
                    publishTime: "",
                    paperName: info.ExamPaperName,
                    classId: info.CustomClassId,
                    ClassName: info.ClassName,
                    startTime: this.currentDay,
                    examUuid: this.genExamUuidAndStartExamStatus()
                }
            })
        },
        Edit(info) {
            this.getNowFormatDate(info)
        },
        // 做卷记录信息
        async paperHistory() {
            const { data } = await GetPaperRecord({
                pageno: this.pageIndex,
                pagesize: this.PageSize,
                sourceType: this.paperSource,
                searchkey: this.keyWord
            });
            if (data.code === 100) {
                this.data = data.data
                this.total = data.count
            }
        },
        // 试卷类别列格式化
        typeFormatter(row, col) {
            if (row.SourceType === "1") {
                return row.CategoryName;
            } else if (row.SourceType === "2") {
                return row.ClassName;
            } else {
                return <el-tag type="danger" size='mini'>其它</el-tag>
            }
        },
        // 答卷用时列格式化
        useTimeFormatter(row, col) {
            return this.timeFn(row.BeginTime, row.EndTime).minutes + "分" + this.timeFn(row.BeginTime, row.EndTime).seconds + "秒"
        },
        // 删除
        Delete(row) {
            try {
                this.$confirm("确认删除记录：" + row.ExamPaperName + "?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.DelPaperRecord(row.Id)
                }).catch(() => {})
            } catch (err) {
                this.$message({ message: "服务器开小差了！", type: "error" })
            }
        },
        // 删除做卷记录
        async DelPaperRecord(Id) {
            const { data } = await DelTestRecord({
                id: Id
            })
            if (data.code === 100) {
                this.$message({ message: "删除成功！", type: "success" })
                if (this.needToPrePage({
                    page: this.pageIndex,
                    pageSize: this.PageSize,
                    total: this.total,
                    delCount: 1
                })) {
                    this.pageIndex--
                }
                this.paperHistory()
            } else {
                this.$message({ message: "服务器开小差了！", type: "error" })
            }
        },
        // 计算考试用时
        timeFn(begin, end) {
            var dateBegin = new Date(begin.replace(/-/g, "/"));
            var dateEnd = new Date(end.replace(/-/g, "/"));
            var dateDiff = dateEnd.getTime() - dateBegin.getTime();
            var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));
            var leave1 = dateDiff % (24 * 3600 * 1000)
            var hours = Math.floor(leave1 / (3600 * 1000))
            var leave2 = leave1 % (3600 * 1000)
            var leave3 = leave2 % (60 * 1000)
            var seconds = Math.round(leave3 / 1000)
            var minutes = Math.floor(leave2 / (60 * 1000))
            let obj = {}
            obj.minutes = hours * 60 + minutes
            obj.seconds = seconds
            if (obj.minutes > 120) {
                obj.minutes = 120
                obj.seconds = 0
            }
            return obj
        },
        // 按钮检索
        BtnQuery() {
            this.pageIndex = 1;
            this.PageSize = 10;
            this.paperHistory()
        },
        PageChange(val) {
            this.pageIndex = val;
            this.paperHistory()
        },
        //
        SizeChange(val) {
            this.PageSize = val
            this.paperHistory()
        }
    }
}

</script>

<style scoped lang="less">

  .recharge {
      width: 100%;
      height: 100%;

    .el-main{
      padding: 0 0 20px 0;
      color: black;
       height: 600px;
        overflow: auto;
       &::-webkit-scrollbar {
           width: 6px;
       }
       &::-webkit-scrollbar-track {
           border-radius: 6px;
       }
       &::-webkit-scrollbar-thumb {
           border-radius: 6px;
           background: #BAC0CA;
       }
    }

   .el-footer{
      bottom: 15px;
      height: 50px;
      line-height: 50px;
      text-align: center;
    }

      .search{
        width: 100%;
        height: 40px;
        line-height: 40px;

        .search-select{
          width:130px;
        }

        .search-text{
          width:250px;
          margin:0 20px 0 0;
        }

        ::v-deep .el-input__inner{
          height: 35px;
        }

      }

    .recharge-data{
      // font-weight:normal;
       color: black;

       .table-btn {
        cursor: pointer;
        margin: 0 5px 0 5px;
      }
    }
    .pagaing{
        margin-top: 40px;
    }
  }

</style>
